import { LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const { logout, selectedClient } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="bg-navbar-bg shadow-lg">
      <div className="max-w-[90%] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div 
            className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate('/configuration')}
          >
            <span className="text-white font-semibold text-2xl">Weborama Enrichment Platform</span>
            {selectedClient && (
              <>
                <span className="text-white font-light text-xl">|</span>
                <span className="text-navbar-text font-semibold text-2xl">{selectedClient}</span>
              </>
            )}
          </div>
          
          <div className="flex items-center gap-3">
            <img 
              src="/LOGO WEBORAMA-BLANC.png" 
              alt="Weborama" 
              className="h-14 w-auto object-contain"
            />
          <Button 
            variant="outline" 
            size="sm" 
            onClick={handleLogout}
            className="flex items-center gap-2 border-white/30 text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm"
          >
            <LogOut className="h-4 w-4" />
            Déconnexion
          </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;